import { pageLocale } from "./locale";
export { worstSeverity } from "./commonfunction";

export const getSelectedPages = (pages) => {
  const selected = pages ? String(pages).split("") : ["0", "1", "2"];
  return {
    showSummary: selected.includes("0"),
    showExercises: selected.includes("1"),
    showHistory: selected.includes("2"),
  };
};

export const getPdfPagePlan = ({ pages, historyPageCount }) => {
  const { showSummary, showExercises, showHistory } = getSelectedPages(pages);
  const plan = [];
  if (showSummary) plan.push("summary");
  if (showExercises) plan.push("exercises");
  if (showHistory) {
    for (let index = 0; index < historyPageCount; index += 1) {
      plan.push(`history-${index}`);
    }
  }
  return plan;
};

export const pageNumberFor = (pagePlan, key) => pagePlan.indexOf(key) + 1;

export const parseSelectedExercises = (raw) => {
  if (!raw) return {};
  return String(raw)
    .split(",")
    .reduce((acc, pair) => {
      const [categoryIndex, exerciseIndex] = pair.split(":").map(Number);
      if (Number.isInteger(categoryIndex) && Number.isInteger(exerciseIndex)) {
        acc[categoryIndex] = exerciseIndex;
      }
      return acc;
    }, {});
};

export const getSelectedExercise = (recommendation, index, selections) => {
  if (!recommendation) return null;
  const exercises = [];
  if (recommendation.exercise?.name) exercises.push(recommendation.exercise);
  if (Array.isArray(recommendation.options)) {
    exercises.push(...recommendation.options.filter((option) => option?.name));
  }
  return exercises[selections[index] || 0] || exercises[0] || null;
};

export const truncateText = (value, maxLength) => {
  if (!value) return "";
  const text = String(value).trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trim()}...`;
};

export const truncateList = (items, maxItems) => {
  if (!Array.isArray(items)) return [];
  return items.slice(0, maxItems);
};

export const normalizeSeverity = (value) => {
  if (!value) return null;
  const normalized = String(value).trim().toLowerCase();
  if (["good", "low", "良好", "低"].includes(normalized)) return "good";
  if (["average", "moderate", "medium", "注意", "中"].includes(normalized)) {
    return "average";
  }
  if (["poor", "bad", "high", "要注意", "高"].includes(normalized)) {
    return "poor";
  }
  return null;
};

export const metricText = (metricKey) => {
  const metrics = pageLocale("metricsv2_metrics") || {};
  const units = pageLocale("metricsv2_units") || {};
  const fallRisk = pageLocale("metricsv2_fallrisk_descriptions") || {};
  return {
    label: metrics[metricKey] || metricKey,
    unit: units[metricKey] || "",
    fallRisk: fallRisk[metricKey] || "",
  };
};
